var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "95%" } },
    [
      _vm.loading
        ? [_c("Loader", { attrs: { delay: 0 } })]
        : [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v("\n              Total PS\n            ")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.feature.properties.total_ps) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v("\n              PS Activos\n            ")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n               " +
                              _vm._s(_vm.feature.properties.ps_activos) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v("\n              PS Activos GN\n            ")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n               " +
                              _vm._s(_vm.feature.properties.ps_activos_gn) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v("\n              PS Activos GLP\n            ")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_activos_glp) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v("\n              PS Potenciales\n            ")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_potenciales) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v("\n              PS Captados\n            ")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_captados) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS No Captablles\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_no_captables) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v("\n              PS Gestión\n            ")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_en_gestion) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS uso residencial\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.feature.properties.ps_residencial) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS uso Cuarto caldera\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n               " +
                              _vm._s(
                                _vm.feature.properties.ps_cuarto_de_caldera
                              ) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS uso Comercial\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n               " +
                              _vm._s(_vm.feature.properties.ps_comercial) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS uso Industrial\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_industrial) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v("\n              PS SAP\n            ")
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.total_ps_sap) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS Potencial SH\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.feature.properties.ps_potencial_sh) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS Potencial SP\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n               " +
                              _vm._s(_vm.feature.properties.ps_potencial_sp) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS Potencial SV\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n               " +
                              _vm._s(_vm.feature.properties.ps_potencial_sv) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS Potencial GC\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_potencial_gc) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS Potencial CC\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_potencial_cc) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS Potencial NE\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_potencial_ne) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS Potencial ES\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_potencial_es) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS Potencial PYME\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_potencial_pyme) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "5" } }, [
                          _vm._v(
                            "\n              PS Potencial CCNE\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("b-col", { attrs: { cols: "1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.feature.properties.ps_potencial_ccne) +
                              "\n            "
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "6" } }, [
                          _vm._v(
                            "\n              Primera puesta en servicio\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "tex-left", attrs: { cols: "4" } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.feature.properties.starting_up_first_date
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "6" } }, [
                          _vm._v(
                            "\n              Última puesta en servicio\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { staticClass: "tex-left", attrs: { cols: "4" } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.feature.properties.starting_up_last_date
                                ) +
                                "\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/DetailsResidencial/Resumen.vue?vue&type=template&id=094b7350&
// module id = null
// module chunks = 